import ApplicationAdapter from '../application';

export default class Field extends ApplicationAdapter {
  namespace = 'schools/v4';
  modelNamePlural = 'options';

  pathForType(type) {
    type = type.replace(/^school-options\/fields?/, `schema/options`);
    return type;
  }
}
